import React from "react";
import { PoolWorkspace } from "@/components/PoolWorkspace";

export default function DesignPool() {
  return <PoolWorkspace kind="design" />;
}
